import { PageListCachedDataSource } from './BaseDataSources';
import { ISeller } from '../Interfaces';

export class CustodianSource extends PageListCachedDataSource<ISeller> {
  public constructor(isActive?: boolean, private _includeUnknown = false) {
    super('/datasource/custodians', { isActive });
  }

  protected getStaticData(): ISeller[] {
    if (this._includeUnknown)
      return [{ internalId: -1, id: '-1', name: 'Unknown', associatedInternalEntity: '' }];
    return [];
  }
}
